module.exports = __webpack_public_path__ + "static/media/logo_conformidades_azul.ef292671.png";